import React from 'react';

import withFormState, {
  WithFormStateProps
} from 'common/components/Form/withFormState';
import SignForm, { SignFormProps } from 'common/components/SignForm';
import { USERSPACE_EMAIL_REGEXP } from 'common/configuration/constants';
import { failFast, isRequired, matchRegex } from 'common/forms/validators';
import trans from 'common/tools/translations/trans';
import { getRecoverPasswordUrl } from 'common/tools/userspace';

type SignInFields = 'email' | 'password';

type Props = Omit<SignFormProps, 'recoverPasswordUrl' | 'submitButtonLabel'>;

const emailValidator = failFast(
  isRequired(trans('error.isrequired')),
  matchRegex(new RegExp(USERSPACE_EMAIL_REGEXP), trans('error.invalid-email'))
);
const SignIn = ({ ...props }: WithFormStateProps<SignInFields> & Props) => (
  <SignForm
    placeholderEmail={trans('userspace.sign-in.placeholder.username')}
    placeholderPassword={trans('userspace.sign-in.placeholder.password')}
    recoverPasswordUrl={getRecoverPasswordUrl()}
    submitButtonLabel={trans('userspace.sign-in.sign-in')}
    {...props}
  />
);

export default withFormState<Props, SignInFields>({
  fields: ['email', 'password'],
  defaultValues: { email: '', password: '' },
  validators: {
    email: [emailValidator],
    password: [isRequired(trans('error.isrequired'))]
  }
})(SignIn);
